import { render, staticRenderFns } from "./checkBrand.vue?vue&type=template&id=0974442c"
import script from "./checkBrand.vue?vue&type=script&lang=ts"
export * from "./checkBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports